var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{staticStyle:{"width":"100%","height":"100%"},attrs:{"chart-data":_vm.data,"chart-options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }